// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableReports_wrapper__3-5uS"};